/**
 * Where to send someone after they sign in.
 *
 * Emails now carry a one-tap sign-in link with the destination baked in, and
 * `ProtectedRoute` passes the page you were trying to reach as `?next=`. Both
 * end up here. Only a path inside this app is ever honoured — an absolute URL,
 * a protocol-relative `//host`, or a `javascript:` payload falls back to the
 * home screen, so a crafted link can't turn our sign-in page into an open
 * redirect.
 *
 * The rule mirrors Better Auth's own `allowRelativePaths` check (which runs
 * server-side on the callback URL), so anything accepted here is also
 * acceptable to the auth server.
 */
const SAFE_NEXT = /^\/(?!\/|\\|%2f|%5c)[\w\-.+/@]*(?:\?[\w\-.+/=&%@]*)?$/i;

export const DEFAULT_NEXT = "/app";

export function safeNextPath(raw: string | null, fallback = DEFAULT_NEXT): string {
  if (!raw) return fallback;
  let value = raw;
  try {
    value = decodeURIComponent(raw);
  } catch {
    return fallback; // malformed escape
  }
  return SAFE_NEXT.test(value) ? value : fallback;
}
